module.exports = __webpack_public_path__ + "static/media/Vector.9a1edbb2.svg";